export const MAX_THREAD_MENTIONS = 10;

export const isMentionAdmin = (userInfo?: any): boolean => {
  return !!(userInfo?.group?.isAdmin);
};

export const getMentionLimit = (userInfo?: any): number => {
  if (isMentionAdmin(userInfo)) return Infinity;
  const apiLimit = Number(userInfo?.mentionLimit);
  if (apiLimit === 0) return Infinity;
  if (Number.isFinite(apiLimit) && apiLimit > 0) return apiLimit;
  return MAX_THREAD_MENTIONS;
};

export const getMentionLimitText = (userInfo?: any): string => {
  const limit = getMentionLimit(userInfo);
  return Number.isFinite(limit) ? String(limit) : '无限';
};

const stripHtml = (text: string = ''): string => text.replace(/<[^>]*>/g, '').trim();

export interface ParsedMention {
  id: string;
  name: string;
}

export const extractMentionsFromHtml = (html: string = ''): ParsedMention[] => {
  if (!html) return [];

  // 从HTML中提取mention标签
  // 格式：<span class="member" data-code="ID">@name</span>
  const regex = /<span\b(?=[^>]*\bclass=["'][^"']*member[^"']*["'])(?=[^>]*\bdata-code=["']([^"']+)["'])[^>]*>(.*?)<\/span>/gi;
  const result: ParsedMention[] = [];
  const seen = new Set<string>();
  let match: RegExpExecArray | null;

  while ((match = regex.exec(html))) {
    const id = String(match[1] || '').trim();
    const rawName = stripHtml(match[2] || '');
    const name = rawName.replace(/^@/, '').trim();
    if (!id || !name || seen.has(id)) continue;
    seen.add(id);
    result.push({ id, name });
  }

  return result;
};

export const mergeMentions = (current: ParsedMention[] = [], incoming: ParsedMention[] = []): ParsedMention[] => {
  const merged: ParsedMention[] = [];
  const seen = new Set<string>();
  [...current, ...incoming].forEach(item => {
    const id = String(item?.id || '').trim();
    const name = String(item?.name || '').trim();
    if (!id || !name || seen.has(id)) return;
    seen.add(id);
    merged.push({ id, name });
  });
  return merged;
};

export const clampMentionsByLimit = (mentions: ParsedMention[] = [], userInfo?: any) => {
  const limit = getMentionLimit(userInfo);
  if (!Number.isFinite(limit)) {
    return {
      allowed: mentions,
      overflow: [] as ParsedMention[],
      limit,
    };
  }

  return {
    allowed: mentions.slice(0, limit),
    overflow: mentions.slice(limit),
    limit,
  };
};
